import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireInternalOrganisation } from '@/lib/staffGate.ts';

/*
 * Skills are Wundo's own product surface: one catalog served to every
 * organisation. Each of the four routes under here was
 * `requiresSuperadminInternal` in the Vue router, so the gate sits on the
 * layout rather than being repeated on each of them.
 */
export const Route = createFileRoute('/_app/skills')({
  beforeLoad: ({ context }) => requireInternalOrganisation(context.queryClient),
  component: () => <Outlet />,
});
